import './assets/chip.css';
import { jsx as e } from "react/jsx-runtime";
import m from "clsx";
import { forwardRef as n } from "react";
import { DEFAULT_COLOR as h, DEFAULT_SIZE as l, DEFAULT_VARIANT as d } from "./utils.js";
const f = "_chip_xsp7e_3", _ = {
  chip: f
}, A = n((o, r) => {
  const {
    children: a,
    className: s,
    color: t = h,
    size: i = l,
    variant: p = d,
    ...c
  } = o;
  return /* @__PURE__ */ e(
    "span",
    {
      ...c,
      ref: r,
      className: m(_.chip, s),
      "data-variant": p,
      "data-size": i,
      "data-color": t,
      children: a
    }
  );
});
A.displayName = "Chip";
export {
  A as Chip
};
